<div class="content">
  <div class="title-bar">
    @if (isNewTransfer()) {
      <h3 class="title">{{ 'NewLine' | SKWTranslate }}</h3>
    } @else if (tabType() === 'TL') {
      <h3 class="title">{{ 'Loading' | SKWTranslate }}</h3>
    } @else {
      <h3 class="title">{{ 'Unloading' | SKWTranslate }}</h3>
    }

    @if (!isNewTransfer()) {
      <iu-storekeeper-button [label]="'Cancel' | SKWTranslate" (onClick)="cancelNewLine()" />
    }
  </div>

  <iu-storekeeper-window-input-scan [(data)]="inputData" (validation)="save()" />

  @if (tabType() === 'UL' || inputData()?.palette || inputData()?.Product) {
    <iu-storekeeper-input
      [label]="'Location' | SKWTranslate"
      [placeholder]="
        (tabType() === 'TL' ? data()?.locator_source?.displayValue : data()?.locator_destination?.displayValue) ?? ''
      "
      [readOnly]="!isNewTransfer()"
      [type]="'text'"
      [validation]="isLocatorCorrect()"
      [value]="inputData()?.locator?.displayValue ?? ''"
      (valueChange)="changeValue('locator', $event)" />
  }

  @if (isPalette() || (isNewTransfer() && !inputData()?.Product)) {
    <iu-storekeeper-input
      [label]="'Pallet' | SKWTranslate"
      [placeholder]="(tabType() === 'TL' ? data()?.palette_source_barcode : data()?.palette_destination_barcode) ?? ''"
      [readOnly]="!isNewTransfer()"
      [type]="'text'"
      [validation]="isPaletteCorrect()"
      [value]="inputData()?.palette?.displayValue ?? ''"
      (valueChange)="changeValue('palette', $event)" />
  }

  @if ((!isNewTransfer() && !isPalette()) || (isNewTransfer() && !inputData()?.palette)) {
    <iu-storekeeper-input
      [label]="'Product' | SKWTranslate"
      [placeholder]="data()?.M_Product_ID?.displayValue ?? ''"
      [readOnly]="!isNewTransfer()"
      [type]="'text'"
      [validation]="isProductCorrect()"
      [value]="inputData()?.Product?.displayValue ?? ''"
      (valueChange)="changeValue('Product', $event)" />

    @if (inputData()?.Product) {
      <iu-storekeeper-input
        [label]="'Quantity' | SKWTranslate"
        [placeholder]="'' + (data()?.Qty ?? '')"
        [type]="'number'"
        [value]="inputData()?.Qty ?? undefined"
        (valueChange)="changeValue('Qty', $event)" />
    }
  }
</div>

<iu-storekeeper-navbar-button
  [icon]="'icon-circle-check'"
  [label]="'Confirm' | SKWTranslate"
  [type]="'confirm'"
  (onClick)="save()" />

<iu-storekeeper-window-panel
  [title]="'DifferentLocation' | SKWTranslate"
  [(isOpen)]="isOpen"
  (cancel)="cancel($event)"
  (confirm)="save(true)">
  <i aria-hidden="true" class="icon icon-triangle-exclamation" icon></i>
  <p class="text" content> {{ 'DifferentLocationMsg' | SKWTranslate }}</p>
</iu-storekeeper-window-panel>
